<script>
import { Bar} from 'vue-chartjs'

export default {
  name: 'MBChart',
  extends: Bar,

  data: function() {
    return {
        chartData : {
            datasets: [
                {
                    data: []
                }
            ]
        },
        options:{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                      displayFormats:{
                        hour: 'DD/MM - H:mm',
                      },
                    },
                    distribution: 'linear',
                    stacked: true
                }],
                yAxes: [{
                    stacked: true,
                    ticks: {
                        min:0
                    }
                }]
            },
            plugins: {
            datalabels: false,
            labels: false
            }
        }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>